// extracted by mini-css-extract-plugin
export default {"btnpwd":"_221a2c3b52"};